import { createApp } from 'vue'
import App from './Otec.vue'

createApp(App).mount('#app-otec')
